import styled from 'styled-components';

import { Image } from 'components/Image';

const StyledImage = styled(Image)`
  width: 20rem;
`;

export { StyledImage };
